<script>import { createEventDispatcher, onMount } from 'svelte';
const dispatch = createEventDispatcher();
let loaded = hasTurnstile();
let mounted = false;
let widgetId;
export let siteKey;
export let appearance = 'always';
export let language = 'auto';
export let formsField = 'cf-turnstile-response';
export let execution = 'render';
export let action = undefined;
export let cData = undefined;
export let retryInterval = 8000;
export let retry = 'auto';
export let theme = 'auto';
export let size = 'normal';
export let forms = true;
export let tabIndex = 0;
onMount(() => {
    mounted = true;
    return () => {
        mounted = false;
    };
});
function hasTurnstile() {
    if (typeof window == 'undefined')
        return null;
    return 'turnstile' in window;
}
function loadCallback() {
    loaded = true;
}
function error() {
    dispatch('turnstile-error', {});
}
function expired() {
    dispatch('turnstile-expired', {});
}
function timeout() {
    dispatch('turnstile-timeout', {});
}
function callback(token) {
    dispatch('turnstile-callback', { token });
}
export function reset() {
    window.turnstile.reset(widgetId);
}
const turnstile = (node) => {
    const id = window.turnstile.render(node, {
        'timeout-callback': timeout,
        'expired-callback': expired,
        'error-callback': error,
        callback,
        sitekey: siteKey,
        'response-field-name': formsField,
        'retry-interval': retryInterval,
        'response-field': forms,
        tabindex: tabIndex,
        appearance,
        execution,
        language,
        action,
        retry,
        theme,
        cData,
        size,
    });
    widgetId = id;
    return {
        destroy: () => {
            window.turnstile.remove(id);
        },
    };
};
</script>

<svelte:head>
    {#if mounted && !loaded}
        <script
            src="https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit"
            on:load={loadCallback}
            async></script>
    {/if}
</svelte:head>

{#if loaded && mounted}
    {#key $$props}
        <div use:turnstile />
    {/key}
{/if}
